import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App/App';
import './styles/tokens.css';
import './main.css';
import { store } from 'redux/store';
import { Provider } from 'react-redux';
import { AccountWrapper } from 'App/AppWrapper/AccountWrapper';
import {
  CustomIntlContextProvider,
  IntlContextProvider,
} from 'context/TranslationContext';
import { MobileContextProvider } from 'context/MobileContext';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './utils/chackra/CustomChackraProvider';
import { colorModeManager } from 'utils/appearance/colorModeManager';
import { AppearanceProvider } from 'utils/appearance/AppearanceProvider';
import { apiAxios } from 'utils/axios';
import { installApiKeyRecovery } from 'utils/auth/recoverApiKey';

// Wired here, not in utils/axios, so importing the axios module stays free of
// side effects and the interceptor gets the store without importing it.
installApiKeyRecovery(apiAxios, { dispatch: store.dispatch });

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

const RootComponent = () => (
  <CustomIntlContextProvider>
    <IntlContextProvider>
      <BrowserRouter>
        <Provider store={store}>
          <AccountWrapper>
            <MobileContextProvider>
              {/* No <ColorModeScript>: rendered inside React it never ran. The
                  pre-paint for both appearance axes is the inline script at the
                  top of public/index.html; the manager reads the same cookie. */}
              <ChakraProvider theme={theme} colorModeManager={colorModeManager}>
                <AppearanceProvider>
                  <App />
                </AppearanceProvider>
              </ChakraProvider>
            </MobileContextProvider>
          </AccountWrapper>
        </Provider>
      </BrowserRouter>
    </IntlContextProvider>
  </CustomIntlContextProvider>
);

ReactDOM.createRoot(container).render(<RootComponent />);
